import React from 'react';
export function PrivacyContent() {
  return <>
      <p className="text-sm uppercase tracking-widest text-gold-400" data-id="element-21">
        Última actualización: Mayo 2026
      </p>

      <p data-id="element-22">
        Tu privacidad es una prioridad para nosotros. Esta política explica qué
        información recopilamos, cómo la usamos y cómo la protegemos cuando
        adquieres el{' '}
        <strong className="text-white font-medium" data-id="element-23">
          Protocolo de Sueño Profundo 50+
        </strong>
        .
      </p>

      <Section title="1. Información que recopilamos" data-id="element-24">
        Recopilamos únicamente los datos necesarios para procesar tu compra y
        entregarte el producto: nombre, correo electrónico y datos de pago
        (procesados de forma segura por nuestros proveedores como Stripe y
        PayPal). No almacenamos información de tu tarjeta en nuestros
        servidores.
      </Section>

      <Section title="2. Uso de tus datos" data-id="element-25">
        Utilizamos tu información para:
        <ul className="list-disc pl-5 mt-3 space-y-1" data-id="element-26">
          <li data-id="element-27">Procesar tu pedido y enviarte acceso al material.</li>
          <li data-id="element-28">Brindarte soporte si lo solicitas.</li>
          <li data-id="element-29">Enviarte comunicaciones relacionadas con tu compra.</li>
          <li data-id="element-30">Mejorar nuestra guía con feedback voluntario.</li>
        </ul>
      </Section>

      <Section title="3. Comunicaciones por correo" data-id="element-31">
        Podrías recibir correos ocasionales con consejos sobre sueño y mejoras a
        la guía. Puedes darte de baja en cualquier momento haciendo clic en el
        enlace de cada correo.
      </Section>

      <Section title="4. Compartir información" data-id="element-32">
        Nunca vendemos, alquilamos ni compartimos tus datos con terceros para
        fines comerciales. Solo compartimos información con proveedores
        estrictamente necesarios (procesador de pagos, plataforma de entrega) y
        bajo estrictos acuerdos de confidencialidad.
      </Section>

      <Section title="5. Cookies" data-id="element-33">
        Nuestro sitio puede utilizar cookies para mejorar la experiencia de
        navegación y medir el rendimiento. Puedes desactivarlas desde tu
        navegador en cualquier momento.
      </Section>

      <Section title="6. Seguridad" data-id="element-34">
        Implementamos medidas técnicas y organizativas para proteger tu
        información: cifrado SSL, acceso restringido y revisiones periódicas de
        seguridad.
      </Section>

      <Section title="7. Tus derechos" data-id="element-35">
        Tienes derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento. Para ejercer estos derechos, escríbenos a
        privacidad@suenoprofundo50.com.
      </Section>

      <Section title="8. Cambios a esta política" data-id="element-36">
        Podemos actualizar esta política ocasionalmente. Los cambios se
        reflejarán en esta misma página con su fecha de actualización
        correspondiente.
      </Section>
    </>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-37">
      <h3 className="text-lg font-serif text-white mb-2" data-id="element-38">{title}</h3>
      <div data-id="element-39">{children}</div>
    </div>;
}